import * as _ from 'lodash';
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import * as DialogActions from 'app/dialog/features/dialog.actions';

import { SPONSOR_GROUP_TOKEN } from 'app/sponsor-group/tokens/sponsor-group.token';
import { CampaignFormService, CampaignService } from 'app/campaign/services';
import { SponsorGroupSchema } from 'app/campaign/structure/sponsor-group';
import { SponsorGroupListService } from '../services/sponsor-group-list.service';
import { SponsorGroupEventHandlerService } from '../services/sponsor-group-event-handler.service';
import { createSponsorGroupList, deleteSponsorGroupList, updateSponsorGroupList } from '../features/sponsor-group/sponsor-group.actions';
import { SponsorGroupListEventHandlerService } from '../services/sponsor-group-list-event-handler.service';
import { takeUntil } from 'rxjs/operators';

class SponsorGroup {
    public state: string = 'first-step';
    public name: string = null;

    public takeUntilSubject: Subject<any> = new Subject();

    constructor(
        public store: Store,
        public campaignService: CampaignService,
        public campaignFormService: CampaignFormService,
        public sponsorGroupListService: SponsorGroupListService,
        public sponsorGroupListEventHandlerService: SponsorGroupListEventHandlerService,
        public sponsorGroupEventHandlerService: SponsorGroupEventHandlerService
    ) {
        this.sponsorGroupListEventHandlerService.onSelectSponsorGroup.pipe(
            takeUntil(this.takeUntilSubject)
        ).subscribe((selected) => {
            this.state = selected ? 'second-step': 'first-step';
            this.name = _.get(selected, 'name', null);
            this.sponsorGroupEventHandlerService.onChangeState.next(this.state);
        });
    }

    onSaveSponsorGroup() {
        const campaign: any = this.campaignFormService.form;
        const raw: any = this.campaignFormService.raw;
    
        const payload: any = this.campaignService.generateRequestObject(campaign, SponsorGroupSchema);
        payload.name = this.name;
        
        this.store.dispatch({
            type: createSponsorGroupList.type,
            campaign: raw,
            payload
        });
    }
    
    onUpdateSponsorGroup() {
        const campaign: any = this.campaignFormService.form;

        const selected = this.sponsorGroupListService.selected;
        const id = selected ? selected.id: null;
        const name = selected ? selected.name: null;

        const payload: any = this.campaignService.generateRequestObject(campaign, SponsorGroupSchema);
        payload.id = id;
        payload.name = name;

        this.store.dispatch({
            type: updateSponsorGroupList.type,
            payload
        });
    }
    
    onDeleteSponsorGroup() {
        const selected = this.sponsorGroupListService.selected;
        const id = selected ? selected.id: null;
        const name = selected ? selected.name: null;
        
        const action = DialogActions.openDialog({
            payload: {
                name: "confirmComponent",
                options: {
                    size: 'small',
                    modalClass:'modal--paybee modal-sm',
                    containerClass:'mdb-modal-backdrop-paybee'
                },
                initialState: {
                    modalTitle: "Are you Sure ?",
                    text: `Do you want to remove sponsor group "${name}" from this campaign ?`,
                    buttonCancel: "No",
                    buttonConfirm: "Yes",
                    callback: (result) => {
                        if(result == false) { return false; }
                        const form: any = this.campaignFormService.form;
                        const schema: any = this.campaignFormService.schema;

                        const campaign: any = this.campaignService.generateRequestObject(form, schema);
                        campaign.id = form.get('id').value;
            
                        this.store.dispatch({
                            type: deleteSponsorGroupList.type,
                            campaign,
                            payload: id
                        });
                    }
                }
            }
        });
        this.store.dispatch(action);
    }
    
    onCreateSponsorGroup() {
        const action = DialogActions.openDialog({
            payload: {
                name: "SponsorGroupName",
                options: {
                    size: 'default',
                    modalClass:'modal--paybee',
                    containerClass:'mdb-modal-backdrop-paybee'
                },
                initialState: {
                    callback: ({ name }) => {
                        this.state = 'second-step';
                        this.name = name;

                        this.sponsorGroupEventHandlerService.onChangeState.next('second-step');
                    }
                }
            }
        });
        this.store.dispatch(action);
    }

    public destroy() {
        this.takeUntilSubject.next(null);
        this.takeUntilSubject.complete();
    }
}

export const SponsorGroupFactory = (
    store: Store,
    campaignService: CampaignService,
    campaignFormService: CampaignFormService,
    sponsorGroupListService: SponsorGroupListService,
    sponsorGroupListEventHandlerService: SponsorGroupListEventHandlerService,
    sponsorGroupEventHandlerService: SponsorGroupEventHandlerService
) => {
    return new SponsorGroup(store, campaignService, campaignFormService, sponsorGroupListService, sponsorGroupListEventHandlerService, sponsorGroupEventHandlerService);
}

export const sponsorGroupProvider = {
    provide: SPONSOR_GROUP_TOKEN,
    useFactory: SponsorGroupFactory,
    deps: [Store, CampaignService, CampaignFormService, SponsorGroupListService, SponsorGroupListEventHandlerService, SponsorGroupEventHandlerService]
};
